<div
  class="item has-edit-button"
  *ngIf="componentType; else configureComponentBlock"
  [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
>
  <div *ngIf="!componentConfig">No component found for {{ componentType }}</div>
  <div *ngIf="isLoading">Loading...</div>
  <div *ngIf="errorMsg">Error loading data: {{ errorMsg }}</div>
  <div *ngIf="isContainerWide; else dynamicCmp" class="grid">
    <div class="container container--wide">
      <div edsRow>
        <div edsCol>
          <ng-template #dynamicCmp></ng-template>
        </div>
      </div>
    </div>
  </div>
  <ng-template #dynamicCmp></ng-template>
</div>
<ng-template #configureComponentBlock
  >Click to configure Interactive Content Component</ng-template
>
